var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5711_6803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.625C18.4203 23.625 23.625 18.4203 23.625 12C23.625 5.57969 18.4203 0.375 12 0.375C5.57969 0.375 0.375 5.57969 0.375 12C0.375 18.4203 5.57969 23.625 12 23.625Z",
    fill: "#2E1834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3299 18.9281C20.2457 17.4765 18.8379 16.2979 17.2183 15.4858C15.5988 14.6737 13.8121 14.2506 12.0004 14.25C10.1886 14.2494 8.40174 14.6715 6.78168 15.4825C5.16162 16.2936 3.75307 17.4714 2.66797 18.9222C3.74755 20.3804 5.15381 21.5654 6.77396 22.3821C8.39412 23.1987 10.1831 23.6244 11.9975 23.625C13.8118 23.6256 15.6011 23.201 17.2217 22.3853C18.8424 21.5697 20.2494 20.3856 21.3299 18.9281Z",
    fill: "#C296CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75C14.4853 12.75 16.5 10.7353 16.5 8.25C16.5 5.76472 14.4853 3.75 12 3.75C9.51472 3.75 7.5 5.76472 7.5 8.25C7.5 10.7353 9.51472 12.75 12 12.75Z",
    fill: "#C296CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5711_6803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user 2.e880c3ff0288203dd88f921cfb30a9b9.svg";
export { ForwardRef as ReactComponent };